import React, { useState } from 'react';
import styles from './SearchTopic.module.scss';
import { SFAutocomplete, SFAutocompleteRefHandler, SFMenuOption } from 'sfui';
import { Topic } from '../../Models';
import { NO_RESULTS_FOUND_MSG } from '../../Constants';

export interface SearchTopicProps {
  className?: string;
  topics: Topic[];
  onSelect: (topicId: string) => void;
  onBlur?: () => void;
}

export const SearchTopic = React.forwardRef<
  SFAutocompleteRefHandler,
  SearchTopicProps
>((props, ref) => {
  const [value, setValue] = useState<string>('');

  const options: SFMenuOption[] = props.topics.map((topic: Topic) => ({
    label: topic.name,
    value: topic.id.toString()
  }));

  const onChange = (value: string | SFMenuOption) => {
    props.onSelect((value as SFMenuOption).value);
    setValue('');
  };

  return (
    <SFAutocomplete
      ref={ref}
      noOptionsText={NO_RESULTS_FOUND_MSG}
      className={`${styles.searchTopic} ${props.className || ''}`}
      label="Search Support"
      popupIconType="search"
      disableClearable
      clearOnBlur
      freeSolo={false}
      options={options}
      value={value}
      onChange={onChange}
      onBlur={props.onBlur}
      aria-label="Search Support"
      placeholder={undefined}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    />
  );
});
